import React from 'react';
import styled from 'styled-components';
import Nav from './Nav';

const HeaderStyles = styled.header`
    top: 0;
    left: 0;
    right: 0;
    background-color: var(--black);
    z-index: 1;
    @media (max-width: 650px) {
        position: fixed;
        z-index: 9;
    }
`;

export default function Header() {
    return (
        <HeaderStyles>
            <Nav />
        </HeaderStyles>
    )
}